<mat-form-field [ngClass]="dateCssClass" appearance="outline" floatLabel="auto" [subscriptSizing]="subscriptSizing">
  <input matInput [matDatepicker]="picker" [formControl]="select" (input)="onInput($event)" (dateChange)="onDateSelection($event)" [placeholder]="placeholder || 'DD/MM/YYYY'" />
  <button matSuffix mat-icon-button aria-label="Clear" (click)="clearDate()" i18n-matTooltip matTooltip="Clear date" *ngIf="select.value && enableClearButton">
    <mat-icon>close</mat-icon>
  </button>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-error *ngIf="ngControl.hasError('dateInvalid')"><ng-container i18n>Choose a date after today</ng-container></mat-error>
  <mat-error *ngIf="ngControl.hasError('required')">{{ fieldLabel }}&nbsp;<ng-container i18n>is required</ng-container></mat-error>
</mat-form-field>
